<template>
    <li @mouseover.once="onMouseover" v-if="isSpecial"
        class="dml-page-nav-item dml-page-nav-item--special-offer dml-page-subcategory js-page-subcategory">
        <a :href="url"
           data-tracking-click="mainNavigation.promo-sale"
           class="dml-page-subcategory__title dml-page-subcategory__title--promo"
           data-ga="mega_menu.click_subcategory" :data-ga-label="name">
            {{ name }}
        </a>
        <dm-mega-menu-special :isLoading="isLoading" :iconsSetVersion="iconsSetVersion" :menuNode="special">

        </dm-mega-menu-special>
    <li v-else :class="cssClass + ' dml-page-subcategory js-page-subcategory'" @mouseover.once="onMouseover">
        <a :class="saleClass + ' dml-page-subcategory__title' " :href="url" data-ga="mega_menu.click_subcategory"
           :data-ga-label="name" data-t="9.5">
            {{ name }}
        </a>
        <div class="dml-page-mega-menu">
            <div class="dml-page-mega-menu__wrap _cf">
                <div class="dml-mega-menu" v-if="!isLoading">
                    <template v-for="menuColumn in menuNode.megaMenuNodes">
                        <ul class="dml-mega-menu__list dml-mega-menu__list--narrow">
                            <template v-for="menuItem in menuColumn.lowLevelItems">
                                <li :class="menuItem.cssClass">
                                    <template v-if="menuItem.url">

                                        <a :href="menuItem.url" :data-tracking-click="menuItem.tracking"
                                           data-ga="mega_menu.click_subcategory_element"
                                           :data-ga-label="menuItem.name">{{ menuItem.name }}</a>

                                    </template>
                                    <span v-else>{{ menuItem.name }}</span>
                                </li>
                            </template>
                        </ul>
                    </template>
                    <dm-mega-menu-banner :iconsSetVersion="iconsSetVersion" :banner="menuNode.bannerViewModel"></dm-mega-menu-banner>
                </div>
                <dm-page-preloader v-else :isLoading="isLoading" :isStatic="true" />
            </div>
        </div>
    </li>
</template>
<script>
import * as types from "../../store/types";
import MegaMenuSpecial from "./mega-menu-special-component.vue";
import MegaMenuBanner from "./mega-menu-banner-component.vue";
import PagePreloader from "../shared/page-preloader-component.vue";

export default {
    name: 'dm-mega-menu',
    components: {
        'dm-mega-menu-special': MegaMenuSpecial,
        'dm-mega-menu-banner': MegaMenuBanner,
        'dm-page-preloader': PagePreloader,
    },
    computed: {
        special() {
            if (this.menuNode.mainNodes !== undefined) {
                return this.menuNode.mainNodes[0];
            }else{
                return {};
            }
        },
        saleClass(){
            return this.menuType === 'Sale'? 'dml-page-subcategory__title--promo' : '';
        }
    },
    data: () => ({
        menuNode: {},
        isLoading: true
    }),
    props: {
        name: {
            type: String
        },
        url: {
            type: String
        },
        cssClass: {
            type: String
        },
        isSpecial: {
            type: Boolean
        },
        iconsSetVersion: String,
        forcePreview: Boolean,
        menuType: {
            type: String
        }
    },
    methods: {
        onMouseover: function () {
            if (this.menuNode.megaMenuNodes == null) {
                this.$store.dispatch(types.FETCH_MEGA_MENU_DATA, this.forcePreview).then(() => {
                    this.isLoading = false;
                    if (this.isSpecial) {
                        this.menuNode = this.$store.state.megaMenu.currentModel.specialOffer;
                    } else {
                        this.menuNode =
                            this.$store.state.megaMenu.currentModel.menuNodes.filter(m => m.url === this.url)[0];
                    }
                });
            }
        }
    }
};
</script>

